<script>
export default {
  components: {},
  props: {},
  mounted() {},
  computed: {
    logoutMessage() {
      const org = process.env.VUE_APP_ORG_ID === '618183d65e84466f63c38878' ? 'Pretty Muscles' : 'SmartFitness';
      console.log({ org });
      return `Are you sure you want to logout from ${org}?`;
    },
  },
  methods: {
    close() {
      this.$bvModal.hide('logout-modal');
    },
  },
};
</script>

<template class="modal-logout">
  <b-modal @hidden="close" id="logout-modal" centered :hide-footer="true" :hide-header="true" size="lg" no-stacking>
    <div @click="close" class="col close">&times;</div>
    <div>
      <p class="modal-text-main">{{ logoutMessage }}</p>
      <div class="actions">
        <BaseButton type="button" class="button btn-secondary btn-round" @click="close">
          No, Cancel
        </BaseButton>
        <BaseButton type="button" class="button btn-secondary btn-round btn-danger">
          <router-link to="/logout" class="col option logout">
            <span>Yes, Logout</span>
          </router-link>
        </BaseButton>
      </div>
    </div>
  </b-modal>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

.modal-dialog > .modal-content {
  .close {
    color: black;
    cursor: pointer;
    font-size: 4rem;
    opacity: 1;
    position: absolute;
    right: 5%;
    top: 5%;
    -webkit-transition-duration: 0.3s;
    width: fit-content;
    &:hover {
      color: darken(#000, 10);
    }
  }
  .modal-text-main {
    color: #030c16;
    font-size: 28px;
    font-style: normal;
    font-weight: 900;
    letter-spacing: -0.233333px;
    line-height: 28px;
    margin: 6rem 4rem;
    text-align: center;
  }
  .actions {
    display: flex;
    justify-content: space-evenly;
    padding-bottom: 2rem;
    padding-top: 2rem;

    .btn-secondary {
      border: 0.28rem solid $color-red;
      color: $color-red;
      font-family: $roboto;
      font-size: 17px;
      font-style: normal;
      font-weight: 500;
      letter-spacing: 1px;
      padding: 0.5rem 1.5rem;
      text-align: center;
      text-transform: capitalize;
      &:hover {
        background-color: transparent;
      }
      &.btn-danger {
        background-color: $color-red;
      }
      a {
        color: #fff;
        font-family: $roboto;
        font-size: 17px;
        font-weight: 500;
        padding: 0;
        text-decoration: none;
      }
    }
  }
}
::v-deep .modal-dialog {
  min-width: 40%;
  .modal-content {
    background: #fff;
    border-radius: 12px !important;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
  }
}
</style>
